const React = require('react');
const ReactDOM = require('react-dom');
const EventEmitter = require('events'); 
const {campaign,globalDataListener,areSameDeep,areSameDeepInst} = require('../lib/campaign.js');
const {displayMessage,snackMessage} = require('./notification.jsx');
import PopoutWindow from './react-popout.jsx';
const {MapView} = require('./map2.jsx');

class PopupMap extends React.Component {
    constructor(props) {
        super(props);

        this.state=this.getState();
        this.datachangeFn = this.datachange.bind(this);
    }

    componentDidMount() {
        popupState.subscribe(this.datachangeFn);
        pointerSync.on("changed", this.datachangeFn);
        globalDataListener.onChangeCampaignContent(this.datachangeFn,"adventure");
        this.datachange(); //  update with current state data
    }
  
    componentWillUnmount() {
        popupState.unsubscribe(this.datachangeFn);
        globalDataListener.removeCampaignContentListener(this.datachangeFn, "adventure");
        pointerSync.removeListener("changed", this.datachangeFn);

        if (this.popoutWindow){
            this.popoutWindow.removeEventListener("resize", this.popupResized.bind(this));
            this.popoutWindow=null;
        }
        if (this.combatants) {
            this.combatants.destroy();
            this.combatants=null;
        }
    }

    datachange(){
        this.setState(this.getState());
    }

    getState() {
        if (!this.combatants && popupState.showPopup) {
            const {EncounterCombatants} = require('./combatants.jsx');

            this.combatants = new EncounterCombatants("campaign",true);
        }

        return({
            popupWidth:popupState.popupWidth||0, 
            popupHeight:popupState.popupHeight||0,
            pointerX:pointerInfo.x, 
            pointerY:pointerInfo.y,
            showPopup:popupState.showPopup,
        });
    }

	render() {
        const t=this;
        const {popupHeight,popupWidth,pointerX,pointerY}= this.state;
        return <span>
            {this.state.showPopup?
                <PopoutWindow 
                    copyStyles={false}
                    name="ShardTabletopMapWindow"
                    title="Shard Tabletop (click in window to maximize)"
                    containerId="map"
                    window={{open:this.openNewWindow.bind(this), 
                        removeEventListener:function(a,b){if (t.popoutWindow) {return t.popoutWindow.removeEventListener(a,b)}},
                        addEventListener:function(a,b){if (t.popoutWindow) {return t.popoutWindow.addEventListener(a,b)}}
                    }}
                    url=""
                    onClosing={this.onClosing.bind(this)}
                >
                    <div className="lightT" onClick={this.onClick.bind(this)}>
                        <link href="https://fonts.googleapis.com/css2?family=Convergence&family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&display=swap" rel="stylesheet"/>
                        <link rel="stylesheet" href={location.origin+"/purple3.min.css"}/>
                        <link rel="stylesheet" href={location.origin+"/base.css"}/>
                        <MapView
                            variant="popout" campaignMode playerView
                            size={{height:popupHeight,width:popupWidth}}
                            pointerX={pointerX} 
                            pointerY={pointerY}
                            combatants={this.combatants}
                        />
                    </div>
                </PopoutWindow>
            : null
            }
        </span>;
    }

    onClosing() {
        popupState.setPopupState(false);
    }

    onClick(){
        const {popoutWindow} = this.state;
    
        if (popoutWindow) {
            toggleFullscreen(popoutWindow.document);
            this.popupResized();
        }
    }

    openNewWindow(url, title, strWindowFeatures) {
        if (this.popoutWindow){
            this.popoutWindow.removeEventListener("resize", this.popupResized.bind(this));
        }
        var newWindow = window.open(url, title, strWindowFeatures);
        newWindow.document.body.style.margin=0;

        this.setState({popoutWindow:newWindow});
        this.popoutWindow = newWindow;
        this.popoutWindow.addEventListener("resize", this.popupResized.bind(this));
        this.popupResized();
        return newWindow;
    }

    popupResized() {
        //console.log("resized", this.popoutWindow.innerWidth, this.popoutWindow.innerHeight);
        if (this.popoutWindow) {
            this.setState({popupWidth:this.popoutWindow.innerWidth, popupHeight:this.popoutWindow.innerHeight})
            popupState.setPopupWindowDimensions(this.popoutWindow.innerWidth, this.popoutWindow.innerHeight)
        }
    }
}

const pointerInfo = {x:0, y:0};
const pointerSync = new EventEmitter();

function setPointer(x,y) {
    pointerInfo.x =x;
    pointerInfo.y=y;
    pointerSync.emit("changed",pointerInfo);
}

function clearPointer() {
    pointerInfo.x=0;
    pointerInfo.y=0;
    pointerSync.emit("changed",pointerInfo);
}

let localMeasureId;

/* View in fullscreen */
function openFullscreen(elem) {
    if (!elem) {
        elem = window.document.body;
    }

    if (elem.requestFullscreen) {
        var res=elem.requestFullscreen({navigationUI:'hide'});
        if (res) {
            res.catch(function (err) {
                console.log("fullscreen Error:"+err);
                //displayMessage("Error entering fullscreen mode:"+err);
            });
        }
    } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
    } else {
        //displayMessage("No fullscreen support found")
    }
}
  
  /* Close fullscreen */
function closeFullscreen(document) {
    if (!document) {
        document = window.document;
    }

    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen();
    }
}

function isFullscreen(document) {
    if (!document) {
        document = window.document;
    }
    return !!document.fullscreenElement;
}

function toggleFullscreen(document) {
    if (isFullscreen(document)) {
        closeFullscreen(document);
    } else {
        openFullscreen(document?document.body:document);
    }
}

class PopupState {
    constructor() {
        this.eventSync = new EventEmitter();
        this.showPopup=false;
    }

    setPopupState(showPopup) {
        this.showPopup = showPopup;
        this.eventSync.emit("changed");
    }

    setGrid(gridOn) {
        this.grid = gridOn;
        if (campaign.getPrefs().grid != gridOn) {
            campaign.setPrefs({grid:gridOn});
        }

        campaign.updateAdventureView({grid:this.grid||false});
        this.eventSync.emit("changed");
    }
    
    setPopupWindowDimensions(width, height) {
        this.popupWidth = width;
        this.popupHeight = height;
        this.eventSync.emit("changed");
    }

    subscribe(fn) {
        this.eventSync.on("changed", fn);
        return fn;
    }

    unsubscribe(fn) {
        this.eventSync.removeListener("changed", fn);
    }
}
const popupState = new PopupState();

export {
    PopupMap, 
    openFullscreen, 
    closeFullscreen, 
    isFullscreen, 
    toggleFullscreen,
    popupState,
    setPointer,
    clearPointer
};